import { createSlice } from "@reduxjs/toolkit";
const usersInitialState = {
  retriveUser: {
    data: null,
    isLoading: false,
    errors: ""
  }
};
export const usersSlice = createSlice({
  name: "USERS",
  initialState: usersInitialState,
  reducers: {
    retriveUserRequestAction: (state, _ref) => {
      let {
        payload: user
      } = _ref;
    } //   state.retriveUser.isLoading = true;
    //   state.retriveUser.errors = "";
    ,
    retriveUserSuccessAction: (state, _ref2) => {
      let {
        payload: user
      } = _ref2;
      //   state.retriveUser.isLoading = false;
      state.retriveUser.data = user;
    },
    retriveUserFailureAction: (state, _ref3) => {
      let {
        payload: error
      } = _ref3;
      //   state.retriveUser.isLoading = false;
      state.retriveUser.errors = error;
    }
  }
});
export const {
  retriveUserRequestAction,
  retriveUserSuccessAction,
  retriveUserFailureAction
} = usersSlice.actions;
export default usersSlice.reducer;